// extracted by mini-css-extract-plugin
export default {"slide":"Slide__slide--3nI","wc":"Slide__wc--2FT","image":"Slide__image--2zo","link":"Slide__link--ujL"};